import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { RegisterStep2Component } from '@pg-app/auth/containers/register/register-step2/register-step2.component';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { DropZoneModule } from '@nttp/drop-zone';
import { PipeModule } from '@nttp/pipes/pipe.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, CoreMaterialModule, CoreUiModule, CommonDialogModule, DropZoneModule, PipeModule],
  declarations: [RegisterStep2Component],
  exports: [RegisterStep2Component]
})
export class RegisterStep2Module { }
// abc
